export default [{
  path: '/login',
  name: 'login',
  meta: {
    layout: 'empty',
    public: true
  },
  component: () => import('@/views/login/index')
}]
